<template>
    <div>
  <v-toolbar flat color="white">
      <v-btn @click="addItem()" outline color="black" small><v-icon class="mr-1">add</v-icon>New Process</v-btn>
        <v-spacer></v-spacer>
        <v-text-field label="Search" v-model="search"></v-text-field>
    </v-toolbar>
    <v-data-table :search="search" :items="processes" :headers="headers" style="cursor: pointer">
        <template v-slot:items="props">
            <td class="justify-center layout px-0">
                <v-icon class="mr-2" @click="editItem(props.item)">edit</v-icon>
                <v-icon @click="deleteItem(props.item.id)">delete</v-icon>
            </td>
            <td class="text-xs-center" @click="openProcess(props.item)">
                {{ props.item.name }}
            </td>
            <td class="text-xs-center" @click="openProcess(props.item)">
                {{ props.item.description }}
            </td>
        </template>
    </v-data-table>
    <v-dialog v-model="processModal" width="750px" persistent>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>{{item.modalType}} Process</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="!item.id" :disabled="!item.name" outline color="black" @click="createProcess()">Save</v-btn>
                <v-btn v-else :disabled="!item.name" outline color="black" @click="updateProcess()">Save</v-btn>

                <v-btn flat @click="processModal=false, item={}">X</v-btn>
            </v-toolbar>
            <v-card-text class="pa-3">
                <v-text-field label="Name" v-model="item.name" box style="font-size: 14px"></v-text-field>
                <v-textarea rows="5" label="Description" v-model="item.description" box style="font-size: 14px"></v-textarea>

            </v-card-text>
        </v-card>
    </v-dialog>
    </div>
</template>
<script>
import Api from "@/services/Api";
export default {
    data: () => ({
        headers: [{
                text: "Action",
                align: "center",
                sortable: false
            },
            {
                text: "Name",
                align: "center",
                value: "name",
            },
            {
                text: "Description",
                align: "center",
                value: "description",
            }
        ],
        item: {},
        processModal: false,
        search: '',
        processes: []
    }),
    created() {
        this.initialise()
    },
    methods: {
        addItem(){
            this.item = {
                modalType: 'Add'
            }
            this.processModal = true
        },
        createProcess(){
             Api().post('/workflows/processes', this.item).then(res => {
                this.initialise()
                this.processModal = false
                this.item = {}
            })
        },
        editItem(item){
            this.item= item
            this.item.modalType = 'Edit'
            this.processModal = true
        },
        deleteItem(item){
            confirm('Are you sure you want to delete this process?')&& 
            Api().put('/workflows/processes/'+item.id, {isActive: false, isDeleted: true}).then(res => {
                this.initialise()
            })
        },
        openProcess(item){
            this.$router.push({path: '/process/'+item.id})
        },
        updateProcess(){
            Api().put('/workflows/processes/'+this.item.id, this.item).then(res => {
                this.initialise()
                  this.processModal = false
                this.item = {}
            })
        },
        initialise() {
            Api().get('/workflows/processes').then(res => {
                this.processes = res.data
            })
        }
    }
}
</script>